<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-subtitle class="uk-text-subheading"
        >Configuración de usuario</mat-card-subtitle
      >
    </mat-card-header>    
    <mat-divider></mat-divider>
    <mat-card-content class="mt-2">
      <app-change-password></app-change-password>
    </mat-card-content>
  </mat-card>
</div>
